var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-responsive"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.src,"title":"Location","width":"600","height":"450","allowfullscreen":"","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }